import React, { useEffect, useState } from "react";
import { Bell, Check, CheckCheck, AlertTriangle, Info, Calendar as Cal, FileText } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { PageHeader, Loading, EmptyState } from "@/components/common";
import { Btn } from "@/components/DataTable";

const ICONS = { schedule: Cal, contract: FileText, compliance: AlertTriangle, report: FileText, info: Info };
const SEV = { warning: "text-amber-600 bg-amber-50", error: "text-red-600 bg-red-50", info: "text-sky-600 bg-sky-50" };

export default function Notifications() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => { setLoading(true); try { const { data } = await api.get("/notifications"); setRows(data); } finally { setLoading(false); } };
  useEffect(() => { load(); }, []);

  const markRead = async (n) => { await api.post(`/notifications/${n.id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div>
      <PageHeader title="Notifications" subtitle="Scheduling, compliance, contracts and operational alerts" icon={Bell}
        actions={<Btn variant="secondary" onClick={markAll} data-testid="mark-all-read-btn"><CheckCheck size={16} /> Mark all read</Btn>} />
      {loading ? <Loading /> : rows.length === 0 ? <EmptyState icon={Bell} title="No notifications" /> : (
        <div className="space-y-2">
          {rows.map((n) => {
            const Icon = ICONS[n.category] || Info;
            return (
              <div key={n.id} data-testid={`notification-${n.id}`} className={`flex items-start gap-3 bg-white border rounded-xl p-4 ${n.read ? "border-slate-200" : "border-seq-green/40 shadow-sm"}`}>
                <div className={`h-9 w-9 rounded-lg flex items-center justify-center shrink-0 ${SEV[n.severity] || SEV.info}`}><Icon size={18} /></div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-slate-800">{n.title}</span>
                    {!n.read && <span className="h-2 w-2 rounded-full bg-seq-green" />}
                  </div>
                  <p className="text-sm text-slate-500 mt-0.5">{n.message}</p>
                  <div className="text-xs text-slate-400 mt-1">{fmtDateTime(n.created_at)}</div>
                </div>
                {!n.read && <button onClick={() => markRead(n)} className="p-1.5 text-slate-400 hover:text-seq-green" data-testid={`read-${n.id}`}><Check size={16} /></button>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
